export const flattenAndLimitCases = (casesData: any[] | null | undefined, isPDFReport: boolean) => {
    return (casesData || []).flatMap((caseRow) =>
        (isPDFReport ? (caseRow.cases ?? []).slice(0, 10) : caseRow.cases ?? []).map((singleCase) => ({
            ...singleCase,
            groupName: caseRow.name,
            groupDesignation: caseRow.designation,
            groupShareholdingPercentage: caseRow.shareholdingPercentage,
        })),
    );
};
